module.exports = __webpack_public_path__ + "static/ben-ac87fdec83a7f683c4de6a2ff165c20c.png";